module.exports = __webpack_public_path__ + "assets/img/faq.e9ec8596.jpg";